import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { useBreadcrumb } from "hooks/useBreadcrumb";
import deletePaymentProfile from "service/paymentServices/DeletePaymentProfile";
import { getPolicyPaymentProfile } from "service/paymentServices/GetPaymentProfile/getPolicyPaymentProfile";

import ConfirmModal from "components/ModalDialogs/ConfirmModal";
import AutoPaymentCard from "components/ManegPayment/AutoPaymentCard";
import GeneralPurposeDialog from "components/General/GeneralPurposeDialog";
import EverlakeLoadingOverlay from "components/General/EverlakeLoadingOverlay";
import AddPaymentMethodModal from "components/ModalDialogs/AddPaymentMethodModal";
import AuthorizeModal from "components/ModalDialogs/AuthedCustomerAuthorizePaymentModal";
import DeleteAutopayPaymentModal from "components/ModalDialogs/DeleteAutopayPaymentModal";
import DeleteAutopayConfirmModel from "components/ModalDialogs/DeleteAutopayConfirmModel";
import DeleteNonAutopayPaymentModal from "components/ModalDialogs/DeleteNonAutopayPaymentModal";
import { useTranslation } from "react-i18next";

export default function ManagePayment() {
  const { t } = useTranslation();
  const { policies } = useSelector((state) => state.data);
  const [autoPaymentData, setAutoPaymentData] = useState([]);
  const [addPaymentModal, setAddPaymentModal] = useState(false);
  const [authorizeModal, setAuthorizeModal] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [deleteAutopayPaymentModal, setDeleteAutopayPaymentModal] =
    useState(false);
  const [deleteNonAutopayPaymentModal, setDeleteNonAutopayPaymentModal] =
    useState(false);
  const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
  const [config, setConfig] = useState("Update");
  const [selectedPaymentProfile, setSelectedPaymentProfile] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);

  const [openDialog, setOpenDialog] = useState(false);
  const [title, setTitle] = useState(false);
  const [message, setMessage] = useState(false);

  async function onSubmit() {
    if (addPaymentModal) {
      setAddPaymentModal(false);
      setConfirmationModal(true);
    } else {
      if (selectedPaymentProfile) {
        //delete Payment Profile
        await deletePaymentProfile(selectedPaymentProfile.paymentProfileId)
          .then((response) => {
            console.log(response);
            if (response.ok) {
              setDeleteConfirmationModal(true);
              setDeleteNonAutopayPaymentModal(false);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }
  useEffect(() => {
    let policyDetails = [];
    policies.map((p) => {
      if (
        p?.creditCard?.recurringReferenceId &&
        p?.creditCard?.recurringReferenceId !== "" &&
        p?.billingTypeCode === "06"
      ) {
        let exstingPolicyDetails = policyDetails?.find(
          (e) => e.paymentProfileId === p?.creditCard?.recurringReferenceId
        );
        if (!exstingPolicyDetails) {
          policyDetails.push({
            paymentProfileId: p?.creditCard?.recurringReferenceId,
            blockCode: p?.blockCode,
            policyId: p?.contractID,
          });
        }
      }
    });
    if (policyDetails?.length > 0) {
      setIsLoading(true);
      getPolicyPaymentProfile(policyDetails)
        .then((response) => {
          let paymentProfile = [];
          if (response?.length > 0) {
            response?.map((p) => {
              if (p?.paymentProfileId) {
                paymentProfile.push({
                  id: p.userId,
                  isDefault: false,
                  type: "Credit Card",
                  accountNumber: `****-****-****-${p.cardNumber}`,
                  ownerName: p.cardHolderName,
                  expDate: `${p.cardExpiryMonth}/${p.cardExpiryYear}`,
                  cardType: p.cardType,
                  cardStatus: p.cardStatus,
                  paymentProfileId: p.paymentProfileId,
                });
              }
            });
          }
          setAutoPaymentData(paymentProfile);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error(t("AuthCustomerPaymentMethods-error-message-1"), error);
          setMessage(t("AuthCustomerPaymentMethods-error-message-1"));
          setTitle(t("AuthCustomerPaymentMethods-error-message-2"));
          setOpenDialog(true);
          setIsLoading(false);
        });
    }
  }, [policies, isUpdated]);

  useBreadcrumb([
    { name: t("CustomerManagePayment-home"), url: "/policies" },
    { name: t("CustomerManagePayment-payments"), url: "/payment" },
    { name: t("ManagePaymentMethods-title"), url: "#" },
  ]);

  return (
    <>
      <EverlakeLoadingOverlay isLoading={isLoading}>
        {!isLoading && (
          <div className="container ui-component-spacing">
            {autoPaymentData?.length > 0 ? (
              <>
                <h1 className="mt-2">{t("ManagePaymentMethods-title")}</h1>
                <div className="ui-paymethod-grid md:mt-12">
                  <div className="ui-grid-cards">
                    {autoPaymentData.map((item, idx) => {
                      return (
                        <AutoPaymentCard
                          data={item}
                          policies={policies}
                          key={idx}
                          isUpdated={isUpdated}
                          setIsUpdated={setIsUpdated}
                        />
                      );
                    })}
                  </div>
                </div>
              </>
            ) : (
              <div className="border border-dashed border-ui-gray p-6 my-6">
                <div className="text-center">
                  <div className="text-xl font-bold">
                    {t("ManagePaymentMethods-no-CreditCards")}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </EverlakeLoadingOverlay>

      {/* Modal Dialogs */}
      <AuthorizeModal
        modalState={authorizeModal}
        setModalState={setAuthorizeModal}
      />

      <ConfirmModal
        modalState={confirmationModal}
        setModalState={setConfirmationModal}
      />
      <DeleteAutopayConfirmModel
        deleteConfirmationModal={deleteConfirmationModal}
        setDeleteConfirmationModal={setDeleteConfirmationModal}
      />

      <AddPaymentMethodModal
        modalState={addPaymentModal}
        setModalState={setAddPaymentModal}
        config={config}
        setConfig={setConfig}
        onSubmit={onSubmit}
      />

      <DeleteAutopayPaymentModal
        modalState={deleteAutopayPaymentModal}
        setModalState={setDeleteAutopayPaymentModal}
        setAddPaymentModal={setAddPaymentModal}
        onSubmit={onSubmit}
      />

      <DeleteNonAutopayPaymentModal
        modalState={deleteNonAutopayPaymentModal}
        setModalState={setDeleteNonAutopayPaymentModal}
        onSubmit={onSubmit}
        data={selectedPaymentProfile}
      />
      <GeneralPurposeDialog
        state={openDialog}
        setState={setOpenDialog}
        title={title}
        desc={message}
      />
    </>
  );
}
